import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/common/Button';
import { Typography } from 'src/components/common/Typography';
import { CmsPage } from 'src/types/cms/cmsCommonTypes';
import { CmsPromotionPageFields } from 'src/types/cms/cmsPageTypes';
import './styles.scss';

type Props = {
  cardInfo: CmsPage<CmsPromotionPageFields> | null;
  onBtnClick: (bonus: CmsPage<CmsPromotionPageFields>) => void;
};

const CardWithInfoPage: FC<Props> = ({ cardInfo, onBtnClick }) => {
  const { t }: Translation = useTranslation();

  const promoUrl = useMemo(() => {
    if (!!cardInfo?.content?.pageFields.cardImage) {
      return cardInfo.content.pageFields.cardImage.path;
    }

    return '';
  }, [cardInfo]);

  return (
    <div className="promotions__bonus-item">
      <div className="promotions__bonus-item-image-wrapper">{promoUrl && <img src={promoUrl} alt="Promotion" />}</div>
      <div className="promotions__item-title-description-button-wrapper">
        {(!!cardInfo?.content?.pageFields.cardTitle || !!cardInfo?.content?.pageFields.cardDescription) && (
          <div className="text_content_wrapper">
            {!!cardInfo?.content?.pageFields.cardTitle && (
              <Typography
                variant={'h6'}
                children={
                  <span
                    className="promotions__item-title"
                    dangerouslySetInnerHTML={{ __html: cardInfo?.content?.pageFields.cardTitle }}
                  />
                }
              />
            )}
            {!!cardInfo?.content?.pageFields.cardDescription && (
              <Typography
                variant={'h6'}
                children={
                  <span
                    className="promotions__item-description"
                    dangerouslySetInnerHTML={{ __html: cardInfo?.content?.pageFields.cardDescription }}
                  />
                }
              />
            )}
          </div>
        )}
        <Button
          onClick={() => cardInfo && onBtnClick(cardInfo)}
          className="promotions__button promotions__button--item  success-filled-btn"
        >
          {t('readMore')}
        </Button>
      </div>
    </div>
  );
};

export default CardWithInfoPage;
